<div class="header d-none d-md-block">
  <h1 class="d-inline-flex v-align-middle astral-heading-with-help">
    <span>{{ title | translate }}</span>
    <astral-popover [helpText]="'VACANT_RENTAL_OBJECT_LIST.HEADER_TOOLTIP'"></astral-popover>
  </h1>
  @if (excelReady) {
    <app-excel-list
      class="btn-list-header"
      [columnDefinition]="excelColumnDefinition"
      [selectedListViewColumns]="selectedColumns"
      [excelContext]="excelContext"
      [filter]="filterState"
      [fileName]="excelFileName"
      [selectedIds]="selectedPremisesIds"
      [affectedItemsCount]="selectedPremisesCount"
      [allSelected]="allPremisesSelected"
      [totalResults]="totalPremises"
    ></app-excel-list>
  }
</div>
<div class="header d-flex d-md-none align-items-center">
  <h1 class="w-100 astral-heading-with-help">
    <span>{{ title | translate }}</span>
    <astral-popover [helpText]="'VACANT_RENTAL_OBJECT_LIST.HEADER_TOOLTIP'"></astral-popover>
  </h1>
  @if (excelReady) {
    <app-excel-list
      [columnDefinition]="excelColumnDefinition"
      [selectedListViewColumns]="selectedColumns"
      [excelContext]="excelContext"
      [filter]="filterState"
      [fileName]="excelFileName"
      [selectedIds]="selectedPremisesIds"
      [affectedItemsCount]="selectedPremisesCount"
      [allSelected]="allPremisesSelected"
      [totalResults]="totalPremises"
      [isMobile]="true"
    ></app-excel-list>
  }
</div>

<section class="astral-stack-s" aria-live="polite">
  @if (excelMetadataLoading) {
    <app-information-block [text]="'VACANT_RENTAL_OBJECT_LIST.EXCEL_EXPORT_LOADING' | translate"></app-information-block>
  } @else if (excelMetadataLoadFailed) {
    <div class="astral-stack-m">
      <app-information-block [text]="'VACANT_RENTAL_OBJECT_LIST.EXCEL_EXPORT_LOAD_FAILED' | translate"></app-information-block>
      <astral-button variant="secondary" size="small" type="button" labelKey="COMMON.TRY_AGAIN" (click)="loadExcelMetadata()"></astral-button>
    </div>
  }
</section>

<app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>

@if (displayGroupedByProperty) {
  <div>
    <app-expanded-list-view
      [columnDefinitions]="columnGroupDefinitions"
      [itemsSource]="dataExpandedList"
      [preferencesKey]="groupedPreferencesKey"
      (rowClick)="onRowClicked($event)"
    ></app-expanded-list-view>
  </div>
}

@if (displayList) {
  <app-multiselect-list-view
    [columnDefinition]="columnDefinition"
    [itemsSource]="itemsSource"
    [contextMenuDefinition]="contextMenuDefinition"
    [menuDefinition]="menuDefinition"
    [preferencesKey]="preferencesKey"
    (onColumnChange)="onColumnChange($event)"
    (selectedItemsChange)="onSelectedPremisesChange($event)"
    [rememberPagination]="true"
    (rowClick)="onRowClicked($event)"
    [isToolbarSticky]="true"
    >
  </app-multiselect-list-view>
}
